export const TEXT = 'TEXT';
export const IMAGE = 'IMAGE';
export const SCENARIO = 'SCENARIO';
export const WARNING = 'WARNING';
export const CALL_ATTEMPT = 'CALL_ATTEMPT';
export const CALL_COMPLETED = 'CALL_COMPLETED';
